module.exports = __webpack_public_path__ + "static/media/image3.0efb6023.png";